<script setup>
import { computed, useSlots } from "vue";

defineProps({
  label: {
    type: String,
    default: null,
  },
  star:{
    type: String,
    default: null,
  },
  help: {
    type: String,
    default: null,
  },
});

const slots = useSlots();

const wrapperClass = computed(() => {
  const base = [];
  const slotsLength = slots.default().length;

  if (slotsLength > 1) {
    base.push("grid grid-cols-1 gap-3");
  }

  if (slotsLength === 2) {
    base.push("md:grid-cols-2");
  }

  return base;
});
</script>

<template>
  <div class="mb-4 last:mb-0 px-2">
    <label
      v-if="label"
      class="block font-semibold text-black-250 text-sm mb-2"
      >{{ label }}
      <span class="text-pink-250 text-base">{{star}}</span>
      </label
    >
    <div :class="wrapperClass">
      <slot />
    </div>
    <div v-if="help" class="text-xs text-gray-500 dark:text-gray-400 mt-1">
      {{ help }}
    </div>
  </div>
</template>
